<template>
  <div class="fixed-timeout" v-if="time > 0" @click="bindJump">
    <img
      class="fixed-image"
      src="https://btw-common-data.betterwestar.com/btw-admin/admin-common-data/2025-04/33da971f03d3c030e30d4bf5e6369e3d_wh=1161_336.webp"
      alt=""
    />
    <div class="timeout-container">
      <van-count-down
        class="my-count-down"
        :time="time"
        format="DD:HH:mm:ss"
        @finish="bindFinish"
      >
        <template #default="timeData">
          <div class="time-container">
            <div class="time-item">{{ timeData.days | fillZero }}</div>
            <div class="time-unit">天</div>
            <div class="time-item">{{ timeData.hours | fillZero }}</div>
            <div class="time-unit">:</div>
            <div class="time-item">{{ timeData.minutes | fillZero }}</div>
            <div class="time-unit">:</div>
            <div class="time-item">{{ timeData.seconds | fillZero }}</div>
            <div class="timeout-text">后失效</div>
          </div>
        </template>
      </van-count-down>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    info: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      time: 0
    }
  },
  filters: {
    fillZero(num) {
      return num < 10 ? '0' + num : num
    }
  },
  created() {
    this.time = this.getTime()
    if (this.time > 0) {
      this.$http.get('member/index?a=shareLogPush', {
        from: `project活动-转介-底部悬浮按钮曝光-${
          this.$route.query.tfrom || ''
        }`,
        from_id: 250422
      })
    }
  },
  methods: {
    bindJump() {
      this.$emit('jump')
      this.$http.get('member/index?a=shareLogPush', {
        from: `project活动-转介-底部悬浮按钮点击-${
          this.$route.query.tfrom || ''
        }`,
        from_id: 250422
      })
    },
    getTime() {
      if ([3, 7].includes(this.info.project_state)) {
        let now = new Date(this.info.server_time.replace(/-/g, '/'))
        let endTime = new Date('2025/05/11 00:00:00')
        let res = endTime.getTime() - now.getTime()
        return res
      } else {
        return 0
      }
    },
    bindFinish() {
      this.time = 0
    }
  }
}
</script>
<style lang="scss" scoped>
.fixed-timeout {
  width: 387px;
  height: 112px;
  position: fixed;
  left: 50%;
  bottom: 20px;
  transform: translate(-50%, 0%);
  .fixed-image {
    width: 100%;
  }
  .timeout-container {
    position: absolute;
    right: 16px;
    top: 15px;
    width: 166px;
    height: 30px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .time-container {
    display: flex;
    align-items: center;
    justify-content: center;

    .time-item {
      width: 16px;
      height: 16px;
      background: #fff;
      border-radius: 2px;
      font-weight: bold;
      font-size: 11px;
      color: #ea3981;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .time-unit {
      margin: 0px 4px;
      font-family: PingFangSC, PingFang SC;
      font-weight: bold;
      font-size: 12px;
      color: #fff;
      text-align: center;
    }

    .timeout-text {
      margin-left: 9px;
      font-family: PingFangSC, PingFang SC;
      font-weight: bold;
      font-size: 12px;
      color: #fff;
    }
  }
}
</style>
